export default "__VITE_ASSET__CjtvHTbr__"